// Must be the first import in index.tsx. Old iPads (iOS < 13.4) run Chrome on an old
// WebKit that lacks these; without them the bundle throws on load (e.g. @formkit/auto-animate
// calls `new ResizeObserver` at import time) and the prerendered page is left unclickable.
import "react-app-polyfill/stable";
import ResizeObserverPolyfill from "resize-observer-polyfill";

if (typeof window !== "undefined" && !("ResizeObserver" in window)) {
    (window as any).ResizeObserver = ResizeObserverPolyfill;
}
